// extracted by mini-css-extract-plugin
export default {"personal_detail_container":"style_personal_detail_container__FzfzJ","error-message":"style_error-message__sUCoM","no_margin":"style_no_margin__eP2iK"};